import { type MatrixClient } from "matrix-js-sdk/src/matrix";

import { getE2EEWellKnown } from "../WellKnownUtils";
import SdkConfig from "../../SdkConfig";

/**
 * Check e2ee io.wicirgot.e2ee setting
 * Returns true when .well-known e2ee config force_disable is TRUE
 * When true all new rooms should be created with encryption disabled
 * Can be overriden by synapse option encryption_enabled_by_default_for_room_type ( :/ )
 * https://matrix-org.github.io/synapse/latest/usage/configuration/config_documentation.html#encryption_enabled_by_default_for_room_type
 *
 * @param client
 * @returns whether well-known config forces encryption to DISABLED
 */
export function shouldForceDisableEncryption(client: MatrixClient): boolean {
    // config.json ha priorità sul .well-known del server
    const configDisableE2EE = SdkConfig.get().disable_e2ee;
    if (configDisableE2EE !== undefined) {
        return configDisableE2EE;
    }

    const e2eeWellKnown = getE2EEWellKnown(client);
    if (e2eeWellKnown) {
        const shouldForceDisable = e2eeWellKnown["force_disable"] === true;
        return shouldForceDisable;
    }
    return false;
}
